import styled, { keyframes, css } from "styled-components";

const shimmer = keyframes`
  0% {
    left: -200%;
  }
  100% {
    left: 100%;
  }
`;

const glow = keyframes`
  0%, 100% {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
  50% {
    box-shadow: 0 12px 30px rgba(42, 244, 151, 0.3);
  }
`;

const selectedGlow = keyframes`
  0%, 100% {
    box-shadow: 0 8px 24px rgba(42, 244, 151, 0.2);
  }
  50% {
    box-shadow: 0 12px 30px rgba(42, 244, 151, 0.4);
  }
`;

export const OurPlansWrapper = styled.div`
  padding: 32px;
  background: transparent;
  height: 100%;
  border-radius: 12px;
  margin: 0 10px;
  position: relative;
  
  h2 {
    color: #2af497;
    margin-bottom: 8px;
    font-size: 1.8rem;
  }
  
  p {
    color: ${props => props.theme.fontColor};
    opacity: 0.8;
    margin-bottom: 24px;
  }
`;

export const PlansButton = styled.button<{disableAnimation?: boolean}>`
  margin-top: 24px;
  background: rgba(30, 30, 40, 0.6);
  backdrop-filter: blur(5px);
  padding: 24px 16px;
  border-radius: 10px;
  width: 100%;
  border: 1px solid rgba(42, 244, 151, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  text-align: left;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-5px);
    border-color: rgba(42, 244, 151, 0.4);
    animation: ${glow} 2s infinite;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -200%;
    width: 200%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(42, 244, 151, 0.1),
      transparent
    );
    ${(props) => props.disableAnimation ? "" : css`animation: ${shimmer} 3s infinite;`}
  }

  span {
    font-size: 1.3rem;
    text-align: center;
    color: #fff;
  }
  
  p {
    margin-top: 5px;
    color: #fff;
    
    span {
      font-size: 0.9rem;
      text-decoration: line-through;
      color: ${props => props.theme.fontColor}80;
    }
  }
  
  &.selected {
    transform: translateY(-5px);
    border-color: rgba(42, 244, 151, 0.7);
    background: rgba(42, 244, 151, 0.1);
    animation: ${selectedGlow} 2s infinite;
    
    &::after {
      content: '✓';
      position: absolute;
      top: 10px;
      right: 10px;
      color: #2af497;
      font-size: 18px;
      font-weight: bold;
    }
    
    span {
      color: #2af497;
    }
  }
`;

export const DiscountTag = styled.div`
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0px;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  
  p {
    margin: 0;
    padding: 6px 10px;
    color: #2af497;
    background-color: rgba(42, 244, 151, 0.1);
    border-radius: 8px;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(42, 244, 151, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;